export const THAI_PROVINCES = [
  'Bangkok',
  'Amnat Charoen',
  'Ang Thong',
  'Bueng Kan',
  'Buri Ram',
  'Chachoengsao',
  'Chai Nat',
  'Chaiyaphum',
  'Chanthaburi',
  'Chiang Mai',
  'Chiang Rai',
  'Chon Buri',
  'Chumphon',
  'Kalasin',
  'Kamphaeng Phet',
  'Kanchanaburi',
  'Khon Kaen',
  'Krabi',
  'Lampang',
  'Lamphun',
  'Loei',
  'Lop Buri',
  'Mae Hong Son',
  'Maha Sarakham',
  'Mukdahan',
  'Nakhon Nayok',
  'Nakhon Pathom',
  'Nakhon Phanom',
  'Nakhon Ratchasima',
  'Nakhon Sawan',
  'Nakhon Si Thammarat',
  'Nan',
  'Narathiwat',
  'Nong Bua Lam Phu',
  'Nong Khai',
  'Nonthaburi',
  'Pathum Thani',
  'Pattani',
  'Phang Nga',
  'Phatthalung',
  'Phayao',
  'Phetchabun',
  'Phetchaburi',
  'Phichit',
  'Phitsanulok',
  'Phra Nakhon Si Ayutthaya',
  'Phrae',
  'Phuket',
  'Prachin Buri',
  'Prachuap Khiri Khan',
  'Ranong',
  'Ratchaburi',
  'Rayong',
  'Roi Et',
  'Sa Kaeo',
  'Sakon Nakhon',
  'Samut Prakan',
  'Samut Sakhon',
  'Samut Songkhram',
  'Saraburi',
  'Satun',
  'Sing Buri',
  'Si Sa Ket',
  'Songkhla',
  'Sukhothai',
  'Suphan Buri',
  'Surat Thani',
  'Surin',
  'Tak',
  'Trang',
  'Trat',
  'Ubon Ratchathani',
  'Udon Thani',
  'Uthai Thani',
  'Uttaradit',
  'Yala',
  'Yasothon',
]

export const THAI_BANKS = [
  'Bangkok Bank (BBL)',
  'Kasikorn Bank (KBANK)',
  'Siam Commercial Bank (SCB)',
  'Krungthai Bank (KTB)',
  'TMBThanachart Bank (TTB)',
  'Bank of Ayudhya / Krungsri (BAY)',
  'CIMB Thai (CIMBT)',
  'Government Savings Bank (GSB)',
  'UOB Thailand (UOBT)',
  'Land and Houses Bank (LHBANK)',
  'Kiatnakin Phatra Bank (KKP)',
  'Tisco Bank (TISCO)',
  'Thai Credit Retail Bank (TCRB)',
  'ICBC Thai (ICBCT)',
  'Standard Chartered (Thai) (SCBT)',
  'Government Housing Bank (GHB)',
  'Bank for Agriculture and Agricultural Cooperatives (BAAC)',
  'Islamic Bank of Thailand (ISBT)',
]

export interface Supplier {
  id: string
  supplierType: 'company' | 'individual'
  name: string
  email: string
  phone: string
  useAsBillingEmail: boolean
  addressLine1: string
  addressLine2: string
  city: string
  province: string
  country: string
  postcode: string
  internalReference: string
  taxId: string
  companyNameTh: string
  companyNameEn: string
  branch: string
  vatRegistered: boolean
  contactPerson: string
  idType: 'citizen_id' | 'passport' | ''
  idNumber: string
  fullNameTh: string
  fullNameEn: string
  individualTaxId: string
  payInMethod: 'acquiring' | 'card'
  cardholderName: string
  cardNumber: string
  expiryDate: string
  payoutMethod: 'bank_account' | 'promptpay'
  bankName: string
  accountNumber: string
  accountName: string
  promptPayType: 'phone' | 'citizen_id' | 'tax_id' | ''
  promptPayId: string
  promptPayName: string
  amountOwed: string
  source: string
  dateCreated: string
  isArchived: boolean
}

export const mockSuppliers: Supplier[] = [
  {
    id: '1',
    supplierType: 'company',
    name: 'Test Company Limited',
    email: 'simon+supplier@pomelopay.com',
    phone: '021234567',
    useAsBillingEmail: true,
    addressLine1: '123/45 Sukhumvit Road',
    addressLine2: 'Khlong Toei, Khlong Toei',
    city: 'Khlong Toei',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10110',
    internalReference: 'SUP-001',
    taxId: '0105563012345',
    companyNameTh: 'บริษัท ทดสอบ จำกัด',
    companyNameEn: 'Test Company Limited',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Somchai Jaidee',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Kasikorn Bank (KBANK)',
    accountNumber: '0381236789',
    accountName: 'Test Company Limited',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 9,393.00',
    source: 'Rabbit Gateway',
    dateCreated: '13/03/2026, 12:26',
    isArchived: false,
  },
  {
    id: '2',
    supplierType: 'company',
    name: 'Premium Tea Estates Ltd',
    email: 'rajesh@premiumtea.th',
    phone: '025559001',
    useAsBillingEmail: true,
    addressLine1: '88 Ratchadaphisek Road',
    addressLine2: 'Din Daeng',
    city: 'Din Daeng',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10400',
    internalReference: 'TEA-002',
    taxId: '0105558001234',
    companyNameTh: 'บริษัท พรีเมียม ที เอสเตท จำกัด',
    companyNameEn: 'Premium Tea Estates Ltd',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Rajesh Kumar',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bangkok Bank (BBL)',
    accountNumber: '2554001289',
    accountName: 'Premium Tea Estates Ltd',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 0.00',
    source: 'Manual entry',
    dateCreated: '10/01/2026, 09:15',
    isArchived: false,
  },
  {
    id: '3',
    supplierType: 'company',
    name: 'Packaging Solutions Co., Ltd.',
    email: 'john@packagingsolutions.th',
    phone: '027778899',
    useAsBillingEmail: false,
    addressLine1: '45/12 Bangna-Trad Road',
    addressLine2: 'Bangna',
    city: 'Bangna',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10260',
    internalReference: 'PKG-003',
    taxId: '0105561009876',
    companyNameTh: 'บริษัท แพ็คเกจจิ้ง โซลูชั่นส์ จำกัด',
    companyNameEn: 'Packaging Solutions Co., Ltd.',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'John Srisuk',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Siam Commercial Bank (SCB)',
    accountNumber: '4081234567',
    accountName: 'Packaging Solutions Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 45,000.00',
    source: 'Rabbit Gateway',
    dateCreated: '05/02/2026, 14:30',
    isArchived: false,
  },
  {
    id: '4',
    supplierType: 'individual',
    name: 'Sompong Chaiyasit',
    email: 'sompong.c@gmail.com',
    phone: '0891234567',
    useAsBillingEmail: true,
    addressLine1: '99/5 Moo 3',
    addressLine2: 'Tambon San Sai Noi',
    city: 'San Sai',
    province: 'Chiang Mai',
    country: 'Thailand',
    postcode: '50210',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: '1100700123456',
    fullNameTh: 'สมปอง ชัยสิทธิ์',
    fullNameEn: 'Sompong Chaiyasit',
    individualTaxId: '1100700123456',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'phone',
    promptPayId: '0891234567',
    promptPayName: 'Sompong Chaiyasit',
    amountOwed: 'THB 0.00',
    source: 'Manual entry',
    dateCreated: '12/11/2025, 11:20',
    isArchived: true,
  },
  {
    id: '5',
    supplierType: 'company',
    name: 'Siam Fresh Produce Co., Ltd.',
    email: 'procurement@siamfresh.co.th',
    phone: '023456789',
    useAsBillingEmail: true,
    addressLine1: '222 Phahonyothin Road',
    addressLine2: 'Chatuchak',
    city: 'Chatuchak',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10900',
    internalReference: 'FRESH-005',
    taxId: '0105560004567',
    companyNameTh: 'บริษัท สยาม เฟรช โปรดิวซ์ จำกัด',
    companyNameEn: 'Siam Fresh Produce Co., Ltd.',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Wanida Thongkham',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Krungthai Bank (KTB)',
    accountNumber: '0621234567',
    accountName: 'Siam Fresh Produce Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 128,500.00',
    source: 'Rabbit Gateway',
    dateCreated: '20/12/2025, 08:45',
    isArchived: false,
  },
  {
    id: '6',
    supplierType: 'company',
    name: 'Thai Digital Print House',
    email: 'sales@thaidigitalprint.com',
    phone: '026789012',
    useAsBillingEmail: true,
    addressLine1: '15/3 Rama 9 Road',
    addressLine2: 'Huai Khwang',
    city: 'Huai Khwang',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10310',
    internalReference: 'PRT-006',
    taxId: '0105562003456',
    companyNameTh: 'บริษัท ไทย ดิจิทัล พริ้นท์ เฮ้าส์ จำกัด',
    companyNameEn: 'Thai Digital Print House Co., Ltd.',
    branch: '00001',
    vatRegistered: true,
    contactPerson: 'Natthapong Lim',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Natthapong Lim',
    cardNumber: '4111XXXXXXXX4242',
    expiryDate: '09/27',
    payoutMethod: 'bank_account',
    bankName: 'TMBThanachart Bank (TTB)',
    accountNumber: '0019876543',
    accountName: 'Thai Digital Print House Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 22,750.00',
    source: 'Manual entry',
    dateCreated: '03/01/2026, 16:10',
    isArchived: false,
  },
  {
    id: '7',
    supplierType: 'company',
    name: 'Eastern Logistics Group',
    email: 'accounts@easternlogistics.co.th',
    phone: '038456789',
    useAsBillingEmail: true,
    addressLine1: '789 Sukhumvit Road',
    addressLine2: 'Nong Prue',
    city: 'Bang Lamung',
    province: 'Chon Buri',
    country: 'Thailand',
    postcode: '20150',
    internalReference: 'LOG-007',
    taxId: '0105559008765',
    companyNameTh: 'บริษัท อีสเทิร์น โลจิสติกส์ กรุ๊ป จำกัด',
    companyNameEn: 'Eastern Logistics Group Co., Ltd.',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Prasert Wongsawat',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank of Ayudhya / Krungsri (BAY)',
    accountNumber: '1234567890',
    accountName: 'Eastern Logistics Group Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 67,200.00',
    source: 'Rabbit Gateway',
    dateCreated: '15/11/2025, 10:30',
    isArchived: false,
  },
  {
    id: '8',
    supplierType: 'individual',
    name: 'Nattaya Suwannapoom',
    email: 'nattaya.s@hotmail.com',
    phone: '0812345678',
    useAsBillingEmail: true,
    addressLine1: '34/2 Soi Nimmanhemin 9',
    addressLine2: 'Suthep',
    city: 'Mueang',
    province: 'Chiang Mai',
    country: 'Thailand',
    postcode: '50200',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: '5500100234567',
    fullNameTh: 'ณัฐยา สุวรรณภูมิ',
    fullNameEn: 'Nattaya Suwannapoom',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Kasikorn Bank (KBANK)',
    accountNumber: '7771234567',
    accountName: 'Nattaya Suwannapoom',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 15,000.00',
    source: 'Manual entry',
    dateCreated: '22/02/2026, 13:45',
    isArchived: false,
  },
  {
    id: '9',
    supplierType: 'company',
    name: 'Green Valley Agriculture',
    email: 'info@greenvalleyag.co.th',
    phone: '044567890',
    useAsBillingEmail: true,
    addressLine1: '56 Mittraphap Road',
    addressLine2: 'Nai Mueang',
    city: 'Mueang',
    province: 'Nakhon Ratchasima',
    country: 'Thailand',
    postcode: '30000',
    internalReference: 'AGR-009',
    taxId: '0105564001122',
    companyNameTh: 'บริษัท กรีน วัลเลย์ แอกริคัลเจอร์ จำกัด',
    companyNameEn: 'Green Valley Agriculture Co., Ltd.',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Kittisak Boonmee',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bank for Agriculture and Agricultural Cooperatives (BAAC)',
    accountNumber: '0201234567',
    accountName: 'Green Valley Agriculture Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 0.00',
    source: 'API',
    dateCreated: '08/09/2025, 09:00',
    isArchived: false,
  },
  {
    id: '10',
    supplierType: 'company',
    name: 'Andaman Seafood Export',
    email: 'export@andamanseafood.com',
    phone: '076234567',
    useAsBillingEmail: false,
    addressLine1: '12/8 Thepkasattri Road',
    addressLine2: 'Rassada',
    city: 'Mueang',
    province: 'Phuket',
    country: 'Thailand',
    postcode: '83000',
    internalReference: 'SEA-010',
    taxId: '0105557006543',
    companyNameTh: 'บริษัท อันดามัน ซีฟู้ด เอ็กซ์ปอร์ต จำกัด',
    companyNameEn: 'Andaman Seafood Export Co., Ltd.',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Apinya Raksa',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Siam Commercial Bank (SCB)',
    accountNumber: '1119876543',
    accountName: 'Andaman Seafood Export Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 234,100.00',
    source: 'Rabbit Gateway',
    dateCreated: '01/06/2025, 11:15',
    isArchived: false,
  },
  {
    id: '11',
    supplierType: 'company',
    name: 'BKK Office Supplies',
    email: 'orders@bkkoffice.co.th',
    phone: '022223333',
    useAsBillingEmail: true,
    addressLine1: '300/1 Silom Road',
    addressLine2: 'Silom, Bang Rak',
    city: 'Bang Rak',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10500',
    internalReference: 'OFF-011',
    taxId: '0105565002233',
    companyNameTh: 'บริษัท บีเคเค ออฟฟิศ ซัพพลายส์ จำกัด',
    companyNameEn: 'BKK Office Supplies Co., Ltd.',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Sumalee Tanaka',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Sumalee Tanaka',
    cardNumber: '5500XXXXXXXX1234',
    expiryDate: '12/28',
    payoutMethod: 'bank_account',
    bankName: 'UOB Thailand (UOBT)',
    accountNumber: '9881234567',
    accountName: 'BKK Office Supplies Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 8,450.00',
    source: 'Manual entry',
    dateCreated: '28/01/2026, 15:20',
    isArchived: false,
  },
  {
    id: '12',
    supplierType: 'individual',
    name: 'Piyawat Sricharoen',
    email: 'piyawat.sri@gmail.com',
    phone: '0867654321',
    useAsBillingEmail: true,
    addressLine1: '77 Soi Lat Phrao 71',
    addressLine2: 'Lat Phrao',
    city: 'Lat Phrao',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10230',
    internalReference: 'FRL-012',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: '1101400567890',
    fullNameTh: 'ปิยวัฒน์ ศรีเจริญ',
    fullNameEn: 'Piyawat Sricharoen',
    individualTaxId: '1101400567890',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'citizen_id',
    promptPayId: '1101400567890',
    promptPayName: 'Piyawat Sricharoen',
    amountOwed: 'THB 3,200.00',
    source: 'Manual entry',
    dateCreated: '14/02/2026, 09:30',
    isArchived: false,
  },
  {
    id: '13',
    supplierType: 'company',
    name: 'Northern Textile Mills',
    email: 'sales@northerntextile.co.th',
    phone: '053789012',
    useAsBillingEmail: true,
    addressLine1: '199 Chiang Mai-Lampang Road',
    addressLine2: 'Nong Hoi',
    city: 'Mueang',
    province: 'Chiang Mai',
    country: 'Thailand',
    postcode: '50000',
    internalReference: 'TXT-013',
    taxId: '0105556007788',
    companyNameTh: 'บริษัท นอร์ทเทิร์น เท็กซ์ไทล์ มิลส์ จำกัด',
    companyNameEn: 'Northern Textile Mills Co., Ltd.',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Anucha Lanna',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'CIMB Thai (CIMBT)',
    accountNumber: '0661234567',
    accountName: 'Northern Textile Mills Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 89,300.00',
    source: 'Rabbit Gateway',
    dateCreated: '19/10/2025, 14:00',
    isArchived: false,
  },
  {
    id: '14',
    supplierType: 'company',
    name: 'Samui Coconut Products',
    email: 'info@samuicoconut.com',
    phone: '077456123',
    useAsBillingEmail: true,
    addressLine1: '33 Moo 2 Maret',
    addressLine2: 'Lamai Beach',
    city: 'Ko Samui',
    province: 'Surat Thani',
    country: 'Thailand',
    postcode: '84310',
    internalReference: 'COC-014',
    taxId: '0105563009900',
    companyNameTh: 'บริษัท สมุย โคโคนัท โปรดักส์ จำกัด',
    companyNameEn: 'Samui Coconut Products Co., Ltd.',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Thanawat Koh',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'tax_id',
    promptPayId: '0105563009900',
    promptPayName: 'Samui Coconut Products Co., Ltd.',
    amountOwed: 'THB 0.00',
    source: 'API',
    dateCreated: '05/07/2025, 10:00',
    isArchived: false,
  },
  {
    id: '15',
    supplierType: 'company',
    name: 'Metro Clean Services',
    email: 'billing@metroclean.co.th',
    phone: '021112222',
    useAsBillingEmail: true,
    addressLine1: '55/9 Petchkasem Road',
    addressLine2: 'Bang Khae',
    city: 'Bang Khae',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10160',
    internalReference: 'CLN-015',
    taxId: '0105561005566',
    companyNameTh: 'บริษัท เมโทร คลีน เซอร์วิสเซส จำกัด',
    companyNameEn: 'Metro Clean Services Co., Ltd.',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Pornchai Meesuk',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Government Savings Bank (GSB)',
    accountNumber: '0551234567',
    accountName: 'Metro Clean Services Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 18,900.00',
    source: 'Manual entry',
    dateCreated: '11/12/2025, 08:30',
    isArchived: false,
  },
  {
    id: '16',
    supplierType: 'individual',
    name: 'Waraporn Jantarakul',
    email: 'waraporn.j@outlook.com',
    phone: '0945556789',
    useAsBillingEmail: true,
    addressLine1: '8/1 Soi Ramintra 34',
    addressLine2: 'Tha Raeng',
    city: 'Bang Khen',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10220',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'passport',
    idNumber: 'AA1234567',
    fullNameTh: 'วราพร จันทรกุล',
    fullNameEn: 'Waraporn Jantarakul',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'promptpay',
    bankName: '',
    accountNumber: '',
    accountName: '',
    promptPayType: 'phone',
    promptPayId: '0945556789',
    promptPayName: 'Waraporn Jantarakul',
    amountOwed: 'THB 0.00',
    source: 'Manual entry',
    dateCreated: '02/03/2026, 11:00',
    isArchived: false,
  },
  {
    id: '17',
    supplierType: 'company',
    name: 'Isaan Rice Trading',
    email: 'trade@isaanrice.co.th',
    phone: '043234567',
    useAsBillingEmail: true,
    addressLine1: '120 Sri Chant Road',
    addressLine2: 'Nai Mueang',
    city: 'Mueang',
    province: 'Khon Kaen',
    country: 'Thailand',
    postcode: '40000',
    internalReference: 'RICE-017',
    taxId: '0105558004455',
    companyNameTh: 'บริษัท อีสาน ไรซ์ เทรดดิ้ง จำกัด',
    companyNameEn: 'Isaan Rice Trading Co., Ltd.',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Somkid Isan',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Krungthai Bank (KTB)',
    accountNumber: '4451234567',
    accountName: 'Isaan Rice Trading Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 156,000.00',
    source: 'Rabbit Gateway',
    dateCreated: '25/08/2025, 13:15',
    isArchived: false,
  },
  {
    id: '18',
    supplierType: 'company',
    name: 'Rayong Rubber Industries',
    email: 'procurement@rayongrubber.co.th',
    phone: '038901234',
    useAsBillingEmail: true,
    addressLine1: '88/3 Sukhumvit Road',
    addressLine2: 'Map Ta Phut',
    city: 'Mueang',
    province: 'Rayong',
    country: 'Thailand',
    postcode: '21150',
    internalReference: 'RBR-018',
    taxId: '0105555003344',
    companyNameTh: 'บริษัท ระยอง รับเบอร์ อินดัสตรีส์ จำกัด',
    companyNameEn: 'Rayong Rubber Industries Co., Ltd.',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Chalerm Pattaya',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Land and Houses Bank (LHBANK)',
    accountNumber: '8881234567',
    accountName: 'Rayong Rubber Industries Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 312,500.00',
    source: 'API',
    dateCreated: '14/04/2025, 09:45',
    isArchived: false,
  },
  {
    id: '19',
    supplierType: 'company',
    name: 'Krabi Tour Operators',
    email: 'finance@krabitours.com',
    phone: '075678901',
    useAsBillingEmail: false,
    addressLine1: '5/2 Utarakit Road',
    addressLine2: 'Pak Nam',
    city: 'Mueang',
    province: 'Krabi',
    country: 'Thailand',
    postcode: '81000',
    internalReference: 'TOUR-019',
    taxId: '0105562008877',
    companyNameTh: 'บริษัท กระบี่ ทัวร์ โอเปอเรเตอร์ส จำกัด',
    companyNameEn: 'Krabi Tour Operators Co., Ltd.',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'Siriporn Andaman',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'card',
    cardholderName: 'Siriporn Andaman',
    cardNumber: '4532XXXXXXXX8901',
    expiryDate: '03/28',
    payoutMethod: 'bank_account',
    bankName: 'Kiatnakin Phatra Bank (KKP)',
    accountNumber: '7771234567',
    accountName: 'Krabi Tour Operators Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 41,600.00',
    source: 'Rabbit Gateway',
    dateCreated: '30/09/2025, 16:30',
    isArchived: false,
  },
  {
    id: '20',
    supplierType: 'company',
    name: 'Old Warehouse Supplies',
    email: 'info@oldwarehouse.co.th',
    phone: '024445555',
    useAsBillingEmail: true,
    addressLine1: '10 Charoen Krung Road',
    addressLine2: 'Talat Noi',
    city: 'Samphanthawong',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10100',
    internalReference: 'WH-020',
    taxId: '0105554001100',
    companyNameTh: 'บริษัท โอลด์ แวร์เฮ้าส์ ซัพพลายส์ จำกัด',
    companyNameEn: 'Old Warehouse Supplies Co., Ltd.',
    branch: '00000',
    vatRegistered: true,
    contactPerson: 'Manop Charoen',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Bangkok Bank (BBL)',
    accountNumber: '1231234567',
    accountName: 'Old Warehouse Supplies Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 0.00',
    source: 'Manual entry',
    dateCreated: '18/05/2024, 10:00',
    isArchived: true,
  },
  {
    id: '21',
    supplierType: 'individual',
    name: 'Anong Petchsri',
    email: 'anong.p@yahoo.com',
    phone: '0823456789',
    useAsBillingEmail: true,
    addressLine1: '42/5 Moo 7',
    addressLine2: 'Tambon Rawai',
    city: 'Mueang',
    province: 'Phuket',
    country: 'Thailand',
    postcode: '83130',
    internalReference: '',
    taxId: '',
    companyNameTh: '',
    companyNameEn: '',
    branch: '',
    vatRegistered: false,
    contactPerson: '',
    idType: 'citizen_id',
    idNumber: '8300100345678',
    fullNameTh: 'อนงค์ เพชรศรี',
    fullNameEn: 'Anong Petchsri',
    individualTaxId: '8300100345678',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Siam Commercial Bank (SCB)',
    accountNumber: '4081239876',
    accountName: 'Anong Petchsri',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 7,500.00',
    source: 'Manual entry',
    dateCreated: '06/01/2026, 14:20',
    isArchived: false,
  },
  {
    id: '22',
    supplierType: 'company',
    name: 'Defunct Trading Co.',
    email: 'old@defuncttrading.com',
    phone: '021110000',
    useAsBillingEmail: true,
    addressLine1: '1 Yaowarat Road',
    addressLine2: 'Samphanthawong',
    city: 'Samphanthawong',
    province: 'Bangkok',
    country: 'Thailand',
    postcode: '10100',
    internalReference: 'DEF-022',
    taxId: '0105550009999',
    companyNameTh: 'บริษัท ดีฟังค์ เทรดดิ้ง จำกัด',
    companyNameEn: 'Defunct Trading Co., Ltd.',
    branch: '00000',
    vatRegistered: false,
    contactPerson: 'N/A',
    idType: '',
    idNumber: '',
    fullNameTh: '',
    fullNameEn: '',
    individualTaxId: '',
    payInMethod: 'acquiring',
    cardholderName: '',
    cardNumber: '',
    expiryDate: '',
    payoutMethod: 'bank_account',
    bankName: 'Tisco Bank (TISCO)',
    accountNumber: '3331234567',
    accountName: 'Defunct Trading Co., Ltd.',
    promptPayType: '',
    promptPayId: '',
    promptPayName: '',
    amountOwed: 'THB 0.00',
    source: 'Manual entry',
    dateCreated: '01/03/2024, 08:00',
    isArchived: true,
  },
]

export interface InvitedSupplier {
  id: string
  name: string
  supplierType: 'company' | 'individual'
  inviteLink: string
  dateInvited: string
  daysAgo: number
}

export const mockInvitedSuppliers: InvitedSupplier[] = [
  {
    id: 'inv-1',
    name: 'Siam Fresh Market Co., Ltd.',
    supplierType: 'company',
    inviteLink: '/supplier-onboarding/a1b2c3d4e5',
    dateInvited: '14/02/2026, 10:30',
    daysAgo: 30,
  },
  {
    id: 'inv-2',
    name: 'Nattapong Srisuk',
    supplierType: 'individual',
    inviteLink: '/supplier-onboarding/f6g7h8i9j0',
    dateInvited: '05/03/2026, 14:15',
    daysAgo: 11,
  },
  {
    id: 'inv-3',
    name: 'Thai Organic Produce Ltd.',
    supplierType: 'company',
    inviteLink: '/supplier-onboarding/k1l2m3n4o5',
    dateInvited: '12/03/2026, 09:00',
    daysAgo: 4,
  },
]
